<div class="theme-name box" (click)="goToGamePicker()">
  <span class="label">{{ I18ns.grid.theme }}</span
  ><br />
  <span class="name">{{ store.theme().name }}</span>
</div>

<router-outlet></router-outlet>

